<template>
  <div
    class="rounded-md caption flex min-h-80 items-center px-12 py-16"
    :class="[emphasis ? 'bg-surface-brand-mid' : 'bg-static-default-mid']"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface VersusTableItemProps {
  emphasis?: boolean
}
defineProps<VersusTableItemProps>()
</script>
